module.exports = __webpack_public_path__ + "static/media/datu.941df98d.png";